import type { VercelRunner } from '@cli-types/next-adapter/vercel.js'

export function pathRunner(): VercelRunner {
  return { bin: 'vercel', prefix: [], source: 'path' }
}
